/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: index.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  26.06.23 5:34 pm.
 * Last modified: 26.06.23 5:34 pm.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';
import { ISectionProps } from '../../Section';
import Body from '../../Section/Body';
import Grid from '../../Section/Grid';
import Header from '../../Section/Header';

const MostPlayedSection = ({
    group,
    count,
    blocks,
    label,
    isViewingAll,
    noHeader,
    onClickViewAll,
    onClickIcon,
    children,
    jackpotComponent,
    placeholder,
    mode,
    visible,
}: ISectionProps) => {
    return (
        <div
            style={!visible ? { display: 'none' } : {}}
            className={`egt_section egt_section_${mode} ${
                isViewingAll ? 'egt_section_fullscreen' : ''
            } egt_section_${group.toLowerCase()}`}
        >
            {!noHeader && (
                <Header
                    icon={`${group}_icon`}
                    label={label}
                    count={count}
                    isViewingAll={isViewingAll}
                    onClickViewAll={onClickViewAll}
                    onClickIcon={onClickIcon}
                />
            )}
            {Boolean(placeholder) && count === 0 && placeholder}
            <Body group={group} jackpotComponent={jackpotComponent} singleView={isViewingAll}>
                <Grid count={blocks} maxRows={!isViewingAll ? 1 : 0} className={'egt_most_played_section'} name={group}>
                    {children}
                </Grid>
            </Body>
        </div>
    );
};

MostPlayedSection.defaultProps = {
    noHeader: false,
    visible: true,
};

export default MostPlayedSection;
